import { getAllLayers } from 'pxc-editor-core/helpers/schema';

import { getFirstSelectedSection } from '@/helpers';
import { SEPARATOR } from '@/constants';

export default ({ sectionsSelection, pages }) => {
  const firstSelSection = getFirstSelectedSection(sectionsSelection, pages);

  if (firstSelSection) {
    const { page, shield } = getAllLayers(firstSelSection?.id, pages);

    if (page.sections) {
      let foundSeparator = false;

      Object.values(page.sections).filter(s => s.shieldId === shield.id).forEach(section => {
        if (section?.type === SEPARATOR) {
          foundSeparator = true;
        }
      });

      return foundSeparator;
    }
  }

  return false;
};
